import { render, staticRenderFns } from "./OfficialHolidayForm.vue?vue&type=template&id=703a1ea1&"
import script from "./OfficialHolidayForm.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports